import {useEffect, useState} from 'react';
import {useForm} from "react-hook-form";
import apiClient from "../../../../utils/apiClient";
import FormSelect from "../../../forms/form-control/FormSelect";
import FormSubmitButton from "../../../forms/form-control/FormSubmitButton";
import {updateStateValue} from "../../../../utils/stateHelpers";
import {isEmpty} from "lodash";
import FormInputDate from "../../../forms/form-control/FormInputDate";
import moment from "moment";

/**
 * Filter component for average downtime by rig.
 * @returns {JSX.Element}
 * @constructor
 */
const AverageDowntimeByRigFilters = (prop) => {
    const {register, handleSubmit, errors, setValue, getValues, clearErrors} = useForm();
    const [disciplines, setDisciplines] = useState([]);
    const [rigs, setRigs] = useState([]);
    const [jobs, setJobs] = useState([]);
    const [financialPeriods, setFinancialPeriods] = useState([]);
    const {data, setData, setFilters} = prop;
    const [endDate, setEndDate] = useState(0);

    // submit handler for report filter
    const onSubmit = (data) => {
        updateStateValue(setFilters, 'isLoading', true);
        updateStateValue(setFilters, 'isSubmitted', true);

        apiClient
            .post('getAverageDowntimeByRig', data)
            .then(response => {
                if (isEmpty(response.data)) {
                    setData([]);
                    return;
                }
                setData(response.data);
            }).then(function () {
            updateStateValue(setFilters, 'isLoading', false);
        });
    }

    // get list of dates
    useEffect(() => {
        apiClient
            .get('getCurrentPayPeriod')
            .then(response => {
                let year = Number(moment(response.data.end_date, 'MM-DD-YYYY').format('YYYY'));
                setEndDate(year);
            });

        // get Disciplines
        apiClient
            .get('getDisciplines')
            .then(response => {
                setDisciplines(
                    response.data.disciplines.map(
                        ({id, name}) => ({id: id, name: name})
                    )
                );
        });

        // get FinancialPeriods
        apiClient
            .get('getFinancialPeriods')
            .then(response => {
                setFinancialPeriods(
                    response.data.map(
                        ({id, name, is_current}) => ({
                            id: id, name: name + (is_current ? ' (Current)' : '')
                        })
                    )
                );
            });
        
        // set yesterday date for date range components
        setValue('date_from', moment().format("YYYY-MM-DD"));
        setValue('date_to', moment().add(2, "month").format("YYYY-MM-DD"));
    }, [setValue, endDate]);

    const setDateByMonthlyPeriod = (value) => {
        if (value) {
            apiClient
                .post('getFinancialPeriodById', {'id': value})
                .then(response => {
                    let startDate = response.data.start_date;
                    let endDate = response.data.end_date;
                    document.getElementById('date_from').value = startDate;
                    document.getElementById('date_to').value = endDate;
                    clearErrors('date_from');
                    clearErrors('date_to');
            });
        }
    }

    // discipline selection handler
    const disciplineSelectionHandler = (e) => {
        setValue('rig_id', null);
        setValue('job_id', null);
        setRigs([]);
        setJobs([]);

        // get Rigs by Discipline
        if (getValues('discipline_id') !== '') {
            apiClient
                .post('getAllActiveRigsByDisciplineId', {'discipline_id': e.target.value})
                .then(response => {
                    const rigItems = response.data.rigs.map(
                        ({id, name}) => ({id: id, name: name})
                    );
                    setRigs(rigItems);
                });
        }
    }

    // rig selection handler
    const rigSelectionHandler = (e) => {
        setValue('job_id', null);
        setJobs([]);

        if (getValues('rig_id') !== '') {
            apiClient
                .post('getActiveJobsByRigId', {'rig_id': e.target.value})
                .then(response => {
                    const jobItems = response.data.jobs.map(
                        ({id, job_number}) => ({id: id, name: job_number})
                    );
                    setJobs(jobItems);
                });
        }
    }

    return (
        <form
            className="needs-validation s-filters-form"
            onSubmit={handleSubmit(onSubmit)}
        >
            <div className="s-filters">
                <FormSelect
                    id="discipline_id"
                    label="Discipline"
                    className="s-filter"
                    onChange={disciplineSelectionHandler}
                    options={disciplines}
                    register={register({required: "required"})}
                    errors={errors}
                />
                <FormSelect
                    id="rig_id"
                    label="Rig"
                    className="s-filter"
                    options={rigs}
                    onChange={rigSelectionHandler}
                    register={register({required: "required"})}
                    errors={errors}
                />
                <FormSelect
                    id="job_id"
                    label="Job"
                    options={jobs}
                    register={register}
                    errors={errors}
                />
                <FormSelect
                    id="financial_period_id"
                    label="Monthly Data Period"
                    className="s-filter"
                    options={financialPeriods}
                    register={register}
                    onChange={(e) => {
                        setValue('pay_period_id', '');
                        setDateByMonthlyPeriod(e.target.value);
                        setValue('date', '');
                    }}
                    errors={errors}
                />
                <FormInputDate
                    id="date_from"
                    label="From"
                    className="s-filter"
                    onChange={() => {
                        setValue('pay_period_id', '');
                        setValue('financial_period_id', '');
                        setValue('date', '');
                        if (isEmpty(getValues('date_to'))) {
                            setValue('date_to', getValues('date_from'));
                        }

                    }}
                    register={register({required: "required"})}
                    errors={errors}
                />
                <FormInputDate
                    id="date_to"
                    label="To"
                    className="s-filter"
                    onChange={() => {
                        setValue('pay_period_id', '');
                        setValue('financial_period_id', '');
                        setValue('date', '');
                    }}
                    register={register({required: "required"})}
                    errors={errors}
                />
                
                <FormSubmitButton
                    label="Show"
                    className="s-button s-button-xl"
                />
                
                {/* For mobile view */}
                {!isEmpty(data) ? (
                    <div className="s-buttons s-justify-between">
                        <FormSubmitButton
                            label="Show"
                            className="s-button"
                        />
                    </div>
                ) : (
                    <div className="s-buttons s-justify-end">
                        <FormSubmitButton
                            label="Show"
                            className="s-button"
                        />
                    </div>
                )}
            </div>
        </form>
    );
}

export default AverageDowntimeByRigFilters;
